<template>
    <fragment>
        <!--一级菜单-->
        <template v-for="(item, index) in menuList">
            <el-submenu
                v-if="item.children && item.children.length"
                :index="item.path"
                :key="item.path + index"
                :style="`padding-left: ${needAddPadding ? '25px' : ''};`"
            >
                <!-- router-link-active -->
                <template slot="title">
                    <i slot="title" class="iconfont Icon" :class="item.meta.icon || ''"></i>
                    <!-- <span slot="title">{{ $t(item.meta.title) || '-'}}</span> -->
                    <span v-if="$t(item.meta.title).length <= sublimitLength">
                    {{ $t(item.meta.title) }}
                </span>
                    <el-tooltip
                        :content="$t(item.meta.title)"
                        raw-content
                        placement="top-start"
                        v-else
                    >
                    <span>
                    {{ $t(item.meta.title).substr(0, sublimitLength) + "..." }}
                    </span>
                    </el-tooltip>
                </template>
                <template>
                    <SidebarMenu :menuList="item.children"></SidebarMenu>
                </template>
            </el-submenu>
            <el-menu-item
                popper-append-to-body
                :index="item.path"
                v-else-if="!overHidden(item)"
                :style="`padding-left: ${needAddPadding ? '30px' : ''};`"
                :key="item.path + index"
            >
                <i class="iconfont Icon" :class="item.meta.icon ? item.meta.icon : ''"></i>
                <!-- <span slot="title" v-if="!item.TOutput">
                    {{ $t(item.meta.title) || '-' }}
                </span> -->
                <template slot="title" v-if="!item.TOutput">
                <span v-if="$t(item.meta.title).length <= limitLength">
                    {{ $t(item.meta.title) }}
                </span>
                    <el-tooltip
                        :content="$t(item.meta.title)"
                        raw-content
                        placement="top-start"
                        v-else
                    >
                    <span>
                    {{ $t(item.meta.title).substr(0, limitLength) + "..." }}
                    </span>
                    </el-tooltip>
                </template>
                <span v-else>{{ item.meta.title }}</span>
            </el-menu-item>
        </template>
    </fragment>
</template>

<script>

export default {
    name: "SidebarMenu",
    components: {},
    props: {
        menuList: {
            type: Array,
            default: () => []
        },
        dns_ym: {
            default: ''
        },
        menuIds: {default: () => []},
        collapse: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            limitLength: 18,
            sublimitLength: 12
        };
    },
    computed: {
        needAddPadding() {
            return !this.collapse;
        },
    },
    mounted() {

    },
    methods: {
        overHidden(item) {
            return !!item.hidden
        }
    }
};
</script>
<style scoped lang='scss'>
@import "@/styles/variables.module.scss";
.Icon {
    font-size: 16px;
    margin: 0 10px 0 -1px;
    color: $base-menu-color;
}

.el-menu-item {
    height: 45px;
    line-height: 45px;
    margin: 6px 15px;
    border-radius: 6px;

    * {
        vertical-align: unset !important;
    }

    &:hover {
        background: rgba(255, 255, 255, 0.1) !important;
    }
}

.el-menu--popup {
    .el-menu-item {
        text-align: unset;
    }
}

.el-menu-item.is-active {
    background-color: $base-background !important;
    color: $base-menu-color-active !important;
}

.el-submenu .el-menu-item {
    height: 40px;
    line-height: 40px;
    padding: 0 25px;
    min-width: 150px;
}

.el-menu--collapse {
    .el-menu-item {
        margin: 0;
    }
}

.hideSidebar {
    .sidebar-container {
        text-align: center;

        .el-menu-item,.el-submenu {
            text-align: center;

            &.is-active {
                border-radius: 0;
            }
        }
    }

    .Icon {
        margin: 0 !important;
    }
}
</style>
